export default {
  // NOTE: These below store user/session specific information
  accessToken: 'access-token',
  localizationCountry: 'localization_country',
  userQuote: 'userquote',
  store: 'store',
  phpSessionId: 'PHPSESSID',
  // NOTE: This was set for some behavior in TYPO3's Account.js
  sessionHash: 'sh',
  loggedIn: 'lg',
  // NOTE: These below are from old login flow.
  fs: 'fs', // TODO: not clear what this is, listed as ['FE']['cookieName'] in typo3 config
  frontend: 'frontend',
};
